var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#929497"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 25.5v-5.1c0-3.3-2.7-5.9-6-5.9s-6 2.6-6 5.9v5.1l-1 2h14l-1-2z",
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "subscribe_svg__st1",
    d: "M21.5 14.5v-2m2 15c0 1.1-.9 2-2 2s-2-.9-2-2",
    fill: "none",
    strokeLinecap: "round"
  })));
}

export default SvgSubscribe;